export default __webpack_public_path__ + "ac98c5163421e5cdb11df03b01f6a826.png";